import { getRequestAction } from 'helpers/functions';

const ACTION_PREFIX = 'ncr';

export const getNCRList = getRequestAction(`${ACTION_PREFIX}/getNCRList`);

export const createNCR = getRequestAction(`${ACTION_PREFIX}/createNCR`);

export const removeNCR = getRequestAction(`${ACTION_PREFIX}/removeNCR`);
